import Axios from "axios";
import config from "../app.config";

export var mailErrorService;
export default mailErrorService = {
    getMailErrors
}

async function getMailErrors(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/mail-error`,{params: data})
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}